


// glide

if(document.querySelector('.page-template-page-atelier')) {
    const gl4 = new Glide('#atelier-slider-thumb', {
        type: 'carousel',
        gap:0,
        perView: 1,
        animationDuration: 3000,
        autoplay:false,
    })
    gl4.mount();
}

if(document.querySelector('.page-template-page-concept')) {
    const gl5 = new Glide('#concept-slider-thumb', {
        type: 'carousel',
        gap:0,
        perView: 1,
        animationDuration: 3000,
        autoplay:false,
    })
    gl5.mount();
}